import { NotFound } from '@/components/ui/states'
import { LumoraSignature } from '@/components/layout/signature'

export function NotFoundPage({ inShell = false }: { inShell?: boolean }) {
  if (inShell) return <NotFound />
  return (
    <div className="flex min-h-dvh flex-col items-center px-6 pb-8 pt-6">
      <div className="flex items-center gap-3">
        <img src="/icons/icon.svg" alt="" aria-hidden width={40} height={40} className="size-10 rounded-[10px]" />
        <LumoraSignature size="lg" />
      </div>
      <main id="main" tabIndex={-1} className="w-full">
        <NotFound />
      </main>
    </div>
  )
}
